import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * TELEFONE TEM WHATSAPP? (Douglas 26/09/2026)
 * Pergunta só quando o lead é aberto (o selo é montado) e junta os números da
 * tela numa chamada. Número já consultado volta do banco, sem nova pergunta ao
 * WhatsApp. `null` = não deu para saber agora (erro não é "não tem").
 */
export interface RespostaWhatsapp { telefone: string; tem_whatsapp: boolean | null; consultado_em: string | null }

export function telefoneCanonico(tel?: string | null): string | null {
  const d = String(tel ?? '').replace(/\D/g, '');
  if (d.length === 10 || d.length === 11) return `55${d}`;
  if ((d.length === 12 || d.length === 13) && d.startsWith('55')) return d;
  return null;
}

let fila: { tel: string; resolver: (r: RespostaWhatsapp | null) => void; falhar: (e: unknown) => void }[] = [];
let agendado: ReturnType<typeof setTimeout> | null = null;

async function despachar() {
  const lote = fila; fila = []; agendado = null;
  const telefones = [...new Set(lote.map((p) => p.tel))].slice(0, 20);
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) throw new Error('Sua sessão expirou. Entre novamente.');
    const base = ((import.meta.env.VITE_SUPABASE_URL as string) || 'https://beta.crm-api.primetecia.com.br/api').replace(/\/$/, '');
    const r = await fetch(`${base}/v1/whatsapp/verificar-numeros`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${session.access_token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ telefones }),
    });
    const corpo = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(corpo.error || 'Não foi possível consultar o WhatsApp.');
    const porTel = new Map<string, RespostaWhatsapp>((corpo.resultados ?? []).map((x: RespostaWhatsapp) => [x.telefone, x]));
    for (const p of lote) p.resolver(porTel.get(p.tel) ?? null);
  } catch (e) {
    for (const p of lote) p.falhar(e);
  }
}

function perguntar(tel: string): Promise<RespostaWhatsapp | null> {
  return new Promise((resolver, falhar) => {
    fila.push({ tel, resolver, falhar });
    if (!agendado) agendado = setTimeout(despachar, 40);
  });
}

export function useWhatsappTelefone(telefone?: string | null) {
  const tel = telefoneCanonico(telefone);
  return useQuery({
    queryKey: ['whatsapp-telefone', tel],
    enabled: !!tel,
    staleTime: Infinity,
    retry: false,
    queryFn: () => perguntar(tel!),
  });
}
